import App from './App.svelte';
import { parkwayCoordinates } from './parkwayCoordinates.json'
import { decodeCategory } from './utils.js'

// var mapId = document.getElementById('map').getAttribute('data-map-id');

var maps = document.querySelectorAll('[data-map-id]'); 

const mapIds = [...maps].map(m => parseInt(m.getAttributeNode("data-map-id").value))


const { hostname } = window.location
let endpoint = hostname === 'localhost' ? `http://localhost:3002/?server=www.blueridgeparkway.org` : `https://brpa.herokuapp.com?server=${hostname}`

// markers.filter((map) => {
fetch(endpoint)
.then(resp => resp.json())
.then(allMaps => {
	// console.log(allMaps)
	allMaps.filter((map) => mapIds.includes(map.map_id))
	.forEach(map => {

		let parsedMap = {
			mapId : map.map_id,
			filterList: map.filter_list,
			height: map.height,
			markers : map.markers,
			parkwayCoordinates
		}

		new App({
			target: document.querySelectorAll(`[data-map-id="${map.map_id}"]`)[0],
			props: parsedMap
		});
	})
})
// })

// // Fetch relevent maps
// fetch('http://map-brpa.pantheonsite.io/wp-json/brpa-maps/v1/maps')
// 	.then(resp => resp.json())
// 	.then(allMaps => {
// 		console.log(allMaps)
// 		// allMaps.filter((map) => {
// 		markers.filter((map) => {
// 			return mapIds.includes(map.map_id);
// 		}).forEach(map => {
// 			let parsedMap = {
// 				mapId : map.map_id,
// 				showFilterList: map.map_points ? map.filter_list : false,
// 				height: map.height,
// 				markers : map.map_points ? map.map_points.map(map_point => ({
// 					...map_point, 
// 	 				categories: !Array.isArray(map_point.category) ? [map_point.category] : map_point.category.map(i => decodeCategory(i.name))
// 				})) : [],
// 				parkwayCoordinates
// 			}

// 			new App({
// 				target: document.querySelectorAll(`[data-map-id="${map.map_id}"]`)[0],
// 				props: parsedMap
// 			});
// 		})
// 	})

// var app = new App({
// 	target: document.getElementById('map'),
// 	props: {
// 		mapId,
// 		markers,
// 		parkwayCoordinates
// 	}
// });

// export default app;